import FacebookAppId from 'types/FacebookAppId';

export default function useFacebookAppId(): FacebookAppId {
  return global.__AT_DATA__.facebookAppId;
}
